import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { isIconFontLoaded, loadIconFont } from "res";
import App from "./App.jsx";

// Node to launch app from:
const container = document.getElementById('root');

// The capture app screenshots the demo as soon as this node gets demo="true", which
// BCMSMenu sets once the menu and model load. Icons that fall back to the icon font are
// blank until its ligatures resolve, so the attribute is withheld until the font has
// painted. The timeout keeps captures from stalling if the font never loads.
const holdCaptureUntilIconFontLoads = node => {
  if(isIconFontLoaded()) { return; }

  const setAttribute = node.setAttribute.bind(node);
  let didRequestCapture = false;
  let isReleased = false;

  node.setAttribute = (name, value) => {
    if(!isReleased && name === "demo" && value === "true") {
      didRequestCapture = true;
      return;
    }

    setAttribute(name, value);
  };

  const release = () => {
    if(isReleased) { return; }

    isReleased = true;
    delete node.setAttribute;

    if(didRequestCapture) { node.setAttribute("demo", "true"); }
  };

  setTimeout(release, 5000);
  loadIconFont().then(() => requestAnimationFrame(() => requestAnimationFrame(release)));
};

holdCaptureUntilIconFontLoads(container);

// index.html hides the demo until it reports ready. A demo that fails to load never
// reports, so its error message would sit behind the loader without this.
setTimeout(() => document.documentElement.classList.add("demo-reveal"), 15000);

// Create a root:
const root = ReactDOMClient.createRoot(container);
// Initial render: Render an element to the root.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
